export default "__VITE_ASSET__DLeVV1Sk__"